// extracted by mini-css-extract-plugin
export default {"Panel":"ActivityPanel_Panel__YTxBG"};